// extracted by mini-css-extract-plugin
export var externalLink = "_92-0";
export var internalLinkLabel = "_92-1";